module.exports = __webpack_public_path__ + "static/img/pjlc-e.c64a10b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/english/pjlc-e.png
// module id = l+jJ
// module chunks = 15